/**
 * Mirrors `PSS_LIMITS` in `@atbash-labs/ontology-ingest` (`pss-ingest/types.ts`).
 * The UI cannot import that package at runtime (Node-only deps), so keep the
 * two in sync when the proxy's bounds change.
 */
export const PSS_WIZARD_LIMITS = {
  minLookbackHours: 1,
  maxLookbackHours: 87_600,
  defaultLookbackHours: 720,
  minRefreshSeconds: 300,
  maxRefreshSeconds: 604_800,
  defaultRefreshSeconds: 3600
} as const

/** Blank tuning fields fall back to proxy defaults; a typed value must be a number in range. */
export function pssTuningValid(fields: Record<string, string>): boolean {
  const inRange = (raw: string | undefined, min: number, max: number) => {
    const trimmed = (raw ?? '').trim()
    if (!trimmed) return true
    const value = Number(trimmed)
    return Number.isFinite(value) && value >= min && value <= max
  }
  return (
    inRange(
      fields.lookbackHours,
      PSS_WIZARD_LIMITS.minLookbackHours,
      PSS_WIZARD_LIMITS.maxLookbackHours
    ) &&
    inRange(
      fields.refreshIntervalSeconds,
      PSS_WIZARD_LIMITS.minRefreshSeconds,
      PSS_WIZARD_LIMITS.maxRefreshSeconds
    )
  )
}
